const US_METHOD_GROUPS = [
  {
    carrier: 'USPS',
    methods: [
      { value: 'USPS_GROUND_ADVANTAGE', label: 'USPS Ground Advantage' },
      { value: 'PRIORITY_MAIL', label: 'USPS Priority Mail' },
    ],
  },
  {
    carrier: 'UPS',
    methods: [
      { value: 'UPS_GROUND', label: 'UPS Ground' },
      { value: 'UPS_3_DAY_SELECT', label: 'UPS 3-Day Select' },
    ],
  },
];

const CANADA_POST_METHODS = {
  CA: [
    {
      value: 'CANADA_POST_REGULAR_PARCEL',
      label: 'Canada Post Regular Parcel',
    },
    {
      value: 'CANADA_POST_EXPEDITED_PARCEL',
      label: 'Canada Post Expedited Parcel',
    },
    {
      value: 'CANADA_POST_XPRESSPOST',
      label: 'Canada Post Xpresspost',
    },
  ],
  US: [
    {
      value: 'CANADA_POST_EXPEDITED_PARCEL_USA',
      label: 'Canada Post Expedited Parcel USA',
    },
    {
      value: 'CANADA_POST_TRACKED_PACKET_USA',
      label: 'Canada Post Tracked Packet USA',
    },
    {
      value: 'CANADA_POST_XPRESSPOST_USA',
      label: 'Canada Post Xpresspost USA',
    },
  ],
  INTERNATIONAL: [
    {
      value: 'CANADA_POST_INTERNATIONAL_PARCEL_AIR',
      label: 'Canada Post International Parcel Air',
    },
    {
      value: 'CANADA_POST_TRACKED_PACKET_INTERNATIONAL',
      label: 'Canada Post Tracked Packet International',
    },
    {
      value: 'CANADA_POST_XPRESSPOST_INTERNATIONAL',
      label: 'Canada Post Xpresspost International',
    },
  ],
};

const GENERIC_GROUP = {
  carrier: 'Generic',
  flatOnly: true,
  note: 'Use for FedEx, DHL, or custom rates.',
  methods: [
    { value: 'GENERIC_GROUND', label: 'Generic Ground' },
    { value: 'GENERIC_PRIORITY', label: 'Generic Priority' },
  ],
};

const LOCAL_PICKUP_GROUP = {
  carrier: 'Local Pickup',
  note: 'Always free. Works with flat rate and calculated shipping modes.',
  methods: [
    { value: 'LOCAL_PICKUP', label: 'Local Pickup (Free)' },
  ],
};

const normalizeCountry = value => String(value || '').trim().toUpperCase();

function getCanadaPostMethods(shipToCountries) {
  const destinations = new Set(
    (Array.isArray(shipToCountries) && shipToCountries.length
      ? shipToCountries
      : ['CA'])
      .map(normalizeCountry),
  );
  const methods = [];

  if (destinations.has('CA')) methods.push(...CANADA_POST_METHODS.CA);
  if (destinations.has('US')) methods.push(...CANADA_POST_METHODS.US);
  if ([...destinations].some(country => !['CA', 'US'].includes(country))) {
    methods.push(...CANADA_POST_METHODS.INTERNATIONAL);
  }

  return methods;
}

export function getShippingMethodGroups({
  originCountry = 'US',
  shipToCountries = [],
  mode,
}) {
  const origin = normalizeCountry(originCountry) || 'US';
  const carrierGroups = origin === 'CA'
    ? [{
      carrier: 'Canada Post',
      note: 'Services are limited to the destinations selected for this product.',
      methods: getCanadaPostMethods(shipToCountries),
    }]
    : US_METHOD_GROUPS;

  return [
    ...carrierGroups.filter(group => group.methods.length),
    GENERIC_GROUP,
    LOCAL_PICKUP_GROUP,
  ].filter(group => !(group.flatOnly && mode === 'calculated'));
}

export function getAllowedShippingMethods(options) {
  return getShippingMethodGroups(options)
    .flatMap(group => group.methods.map(method => method.value));
}
